import { GetDate } from '../../../../utils/Show';
import { TextCapitalize } from '../../../../utils/TextFormatter';
import cn from '../../../../utils/cn';

function Container({ children, cardTitle, className }) {
    return (
        <div
            className={cn(
                'relative max-h-[100px] w-full md:max-w-[320px] p-5 !pb-2.5 bg-[rgba(0,145,110,0.5)] rounded-10 border border-[rgba(255,255,255,0.5)]',
                className
            )}
        >
            {children}

            {cardTitle ? (
                <span className="flex items-center justify-center min-h-7 bg-white text-primary text-base font-normal absolute -top-4 left-4 px-2.5 rounded-[7px] box-border">
                    {cardTitle}
                </span>
            ) : null}
        </div>
    );
}

function InfoRow({ title, value }) {
    return (
        <div className="flex gap-x-2 text-base text-white">
            <div className="whitespace-nowrap">
                <span>{title}:</span>
            </div>
            <div className="whitespace-nowrap">
                <span>{value || '------'}</span>
            </div>
        </div>
    );
}

function CustomerInfo({ data }) {
    return (
        <Container cardTitle="Customer Info">
            <InfoRow title="Name" value={data?.user?.fullName} />
            <InfoRow title="Email" value={data?.user?.primaryEmail} />
            <InfoRow title="Phone" value={data?.user?.primaryPhone} />
        </Container>
    );
}

function ServiceStatusInfo({ data }) {
    return (
        <Container cardTitle="Service Status">
            <InfoRow title="Status" value={TextCapitalize(data?.status)} />
            <InfoRow title="Initiated" value={GetDate(data?.timeInitiate)} />
            <InfoRow title="Last Updated" value={GetDate(data?.timeUpdated)} />
        </Container>
    );
}

function ServiceTimeline({ data }) {
    return (
        <Container cardTitle="Timeline">
            <InfoRow title="Implement" value={GetDate(data?.timeImplement) || 'Not yet'} />
            <InfoRow title="Ongoing" value={GetDate(data?.timeOngoing) || 'Not yet'} />
            <InfoRow title="Completed" value={GetDate(data?.timeDone) || 'Not yet'} />
        </Container>
    );
}

function ServicePeriod({ data }) {
    return (
        <Container cardTitle="Service Period">
            <InfoRow title="Start Date" value={GetDate(data?.timeServiceStart)} />
            <InfoRow title="End Date" value={GetDate(data?.timeServiceEnd) || 'One Time'} />
            <InfoRow title="Package" value={data?.packageName || data?.serviceName || '------'} />
        </Container>
    );
}

function ServiceInfoCard({ data }) {
    return (
        <div className="flex flex-wrap lg:flex-nowrap gap-y-6 gap-x-2.5 relative z-10">
            <CustomerInfo data={data} />
            <ServiceStatusInfo data={data} />
            <ServiceTimeline data={data} />
            <ServicePeriod data={data} />
        </div>
    );
}

export default ServiceInfoCard;
